import { call, put, takeLatest } from "redux-saga/effects";
import { UPLOAD_NOC, DOWNLOAD_NOC_DOCUMENT, FILTER_NOC_DOCUMENT, DELETE_NOC_LIST } from "./actionType";
import { uploadNocDocumentSuccess, uploadNocDocumentError, downloadNocDocumentSuccess, downloadNocDocumentError, filterNocDocumentSuccess, filterNocDocumentError, deleteNocList_Id_Success } from "./action";
import { NocImageUpload, nocDocumentDelete, nocDownload, nocdocumentFilter } from "../../../helpers/backend_helper";
import SERVER_HOST_PATH from "../../../helpers/_serverPath";

// === Upload NOC Saga ===
function* uploadNocDocumentSaga({ config }) {
  try {
    const response = yield call(NocImageUpload, config);
    yield put(uploadNocDocumentSuccess(response));
  } catch (error) {
    yield put(uploadNocDocumentError(error?.message || "Upload failed"));
  }
}

// === Download NOC Document Saga ===
function* nocDownloadSaga({ payload }) {
  try {
    const response = yield call(nocDownload, { jsonBody: payload });

    if (response?.StatusCode === 204 && response?.Status === true) {
      yield put(downloadNocDocumentSuccess(response));
      return;
    }

    if (response?.StatusCode === 200 && response?.Data?.length > 0) {
      let filePath = response.Data[0].FilePath || "";
      const cleanedPath = filePath.replace(/\\/g, "/").trim();
      const fullUrl = cleanedPath.startsWith("http")
        ? cleanedPath
        : `${SERVER_HOST_PATH}/media/${cleanedPath}`;
      yield put(downloadNocDocumentSuccess({ imageUrl: fullUrl }));
      return;
    }

    yield put(downloadNocDocumentError("No document found"));
  } catch (error) {
    yield put(downloadNocDocumentError(error?.message || "Download failed"));
  }
}

// === Filter NOC Document Saga ===
function* filterNocDocumentSaga({ payload }) {
  try {
    const response = yield call(nocdocumentFilter, { jsonBody: payload });

    if (response?.Status === true) {
      const data = Array.isArray(response.Data) ? response.Data : [];
      const monthNames = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
      ];

      const dataWithFormattedMonth = data.map(item => {
        const createdDate = item.CreatedOn
          ? new Date(item.CreatedOn)
          : null;
      
        const formattedCreatedOn = createdDate
          ? `${String(createdDate.getDate()).padStart(2, "0")}-${String(createdDate.getMonth() + 1).padStart(2, "0")}-${createdDate.getFullYear()} ${createdDate.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}`
          : "";
      
        const monthName = monthNames[item.Month - 1];
        const formattedMonthYear = `${monthName} ${item.Year}`;
      
        return {
          ...item,
          Month: `${formattedMonthYear} (${formattedCreatedOn})`, // ✅ FINAL OUTPUT
        };
      });
      
      yield put(filterNocDocumentSuccess({
        ...response,
        Data: dataWithFormattedMonth,
        Month: `${payload.Year}-${String(payload.Month).padStart(2, "0")}`,
        selectedSupplier: payload.Supplier ? { value: payload.Supplier, label: "" } : null,
        Supplierid: payload.Supplier,
        Partyid: payload.PartyID
      }));
    } else {
      yield put(filterNocDocumentError("Failed to fetch NOC list."));
    }
  } catch (error) {
    yield put(filterNocDocumentError(error?.message || "API call failed."));
  }
}

// === Delete NOC Document Saga ===
function* deleteNOCListSaga({ payload }) {
  try {
    const monthNames = [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];

    const monthString = (payload.rowData.Month || "").split(" ")[0];
    const Month = monthNames.findIndex(
      m => m.toLowerCase() === monthString.toLowerCase()
    ) + 1;

    const jsonBody = {
      Supplier: payload.rowData.Supplierid,
      PartyID: payload.rowData.Partyid,
      Month: Month,
      Year: payload.rowData.Year,
    };

    const response = yield call(nocDocumentDelete, { jsonBody });

    if (response?.Status === true) {
      yield put(deleteNocList_Id_Success({
        ...response,
        DeletedId: payload.rowData.id // send deleted row id
      }));
    }
  } catch (error) {
    yield put(filterNocDocumentError(error?.message));
  }
}
export default function* NocSaga() {
  yield takeLatest(UPLOAD_NOC, uploadNocDocumentSaga);
  yield takeLatest(DOWNLOAD_NOC_DOCUMENT, nocDownloadSaga);
  yield takeLatest(FILTER_NOC_DOCUMENT, filterNocDocumentSaga);
  yield takeLatest(DELETE_NOC_LIST, deleteNOCListSaga);
}